import NearMissListTable from "./components/NearMissListTable";

export default NearMissListTable